/* global axios */

import ApiClient from './ApiClient';

class AccountActions extends ApiClient {
  constructor() {
    super('actions', { accountScoped: true });
  }

  merge(parentId, childId) {
    return axios.post(`${this.url}/contact_merge`, {
      base_contact_id: parentId,
      mergee_contact_id: childId,
    });
  }

  mergeConversations({
    targetConversationId,
    sourceConversationIds,
    transitionMessages,
  }) {
    return axios.post(`${this.url}/conversation_merge`, {
      target_conversation_id: targetConversationId,
      source_conversation_ids: sourceConversationIds,
      transition_messages: transitionMessages,
    });
  }
}

export default new AccountActions();
